import sha512 from 'crypto-js/sha512';
import hex from 'crypto-js/enc-hex';
import IRegisterForm from '@/app/auth/register/IRegisterForm';
import IRegisterApi from '@/app/auth/register/IRegisterApi';

export default class AuthFactory {
  public static initRegisterForm(): IRegisterForm {
    return {
      countryId: null,
      firstName: '',
      languageId: null,
      lastName: '',
      login: '',
      mail: '',
      password: '',
      passwordRepeat: '',
      phoneNumber: null,
      recaptcha: '',
      hasAgreed: false,
    };
  }

  static toRegisterApi(api: IRegisterForm): IRegisterApi {
    const apiCopy = { ...api };
    return {
      countryId: api.countryId as number,
      firstName: api.firstName,
      languageId: api.languageId as number,
      lastName: api.lastName,
      login: api.login,
      mail: api.mail,
      password: sha512(apiCopy.password).toString(hex),
      phoneNumber: api.phoneNumber as number,
      recaptcha: api.recaptcha,
    };
  }
}
